// Backwards-compat shim. Implementation was split on 2026-04-25 from a
// 1,200-line god file into focused modules:
//
//   types.ts            — domain types (StockData, StockFactors, PillarScores, ScoredStock, StockOverride)
//   peer-groups.ts      — bank/energy/utility/REIT classification + getPeerGroup
//   scoring-helpers.ts  — clamp, computeStats, zscoreVal, winsorize, avgZ
//   pillar-factors.ts   — PILLAR_FACTORS data table (financial vs nonFinancial)
//   factor-pipeline.ts  — computeFactors (the big arithmetic pipeline)
//   scoring.ts          — scoreGroup + scoreStocks (the z-score engine)
//   factor-config.ts    — FactorConfig/PillarMapping/QualityPillar + DEFAULT_PILLAR_WEIGHTS
//
// New code should import directly from the focused modules above. Existing
// code that imports from '@/lib/compute' continues to work via the re-exports
// below — no behavior change, no math change.

export type {
  StockData,
  StockFactors,
  PillarScores,
  ScoredStock,
  StockOverride,
  OverridesMap,
} from './types';

export type { FactorConfig, QualityPillar } from './factor-config';

export {
  BANK_INDUSTRIES,
  ENERGY_INDUSTRIES,
  UTILITY_INDUSTRIES,
  REIT_INDUSTRIES,
  isBankLike,
  isEnergyLike,
  isUtilityLike,
  isREITLike,
  getPeerGroup,
} from './peer-groups';
export type { PeerGroup } from './peer-groups';

export { PILLAR_FACTORS } from './pillar-factors';

export { computeFactors } from './factor-pipeline';

export { scoreStocks } from './scoring';
